module.exports = __webpack_public_path__ + "fonts/AkkBdIt_Pro_1.2d970c4.otf";